<script setup>
// assets/project/src/views/ListExperts.vue

import {Pagination, Spin} from "ant-design-vue";
import {ref, defineEmits, computed} from "vue";
import axios from "axios";
import competitionServices from "@/services/competitionServices";
import moment from "moment/moment";
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";

let isLoading = ref(false);
let tab = ref(1);

let competitions = ref([]);

async function getData() {
	isLoading.value = true;
	await getCompetitions();
	isLoading.value = false;
}

getData();

let current = ref(1);
let pageSize = ref(10);

const paginatedCompetitions = computed(() => {
	const start = (current.value - 1) * pageSize.value;
	const end = start + pageSize.value;
	return competitions.value.slice(start, end);
})

async function getCompetitions() {
	const response = await axios.get('/competition/get_experts_competitions');
	competitions.value = response.data;
}

function getCompetitionNapravlenie(competition) {
	return competitionServices.getNapravlenie(competition);
}

function formatDate(date) {
	return moment(date).format('D MMMM YYYY');
}

const emit = defineEmits(['choise_competition'])


function choise_competition(categoryId) {
	emit('choise_competition', categoryId)
}

const need_score = computed(() => {
	let res = 0;
	competitions.value.forEach((competition) => {
		competition.categories_data.forEach((category) => {
			if (category.notScoredProjects > 0) {
				res = res + category.notScoredProjects;
			}
		})
	});
	return res;
})

const currentUserEmail = computed(() => {
	return window.currentUserEmail;
})

function get_uploaded_image_asset(path) {
	return ImageService.getCompetitionImagePath(path);
}



</script>

<template>
    <div>
        <div class="gray_line">
            <div class="gray_inner">
                <div class="item" :class="tab === 1 ? 'active' : ''" @click="tab = 1">Требуется оценка
<!--										<span class="has_not_scored">{{ need_score }}</span>-->
								</div>
            </div>
        </div>
        <div class="request_content">
            <template v-if="!isLoading">
                <h2>Выберите категорию конкурса</h2>

                <div class="content_block">
<!--                    <div class="content_block__item" style="padding-bottom: 0;">-->
<!--                        <template v-if="currentUserEmail === 'nigmatullina.a.h@mail.ru' || currentUserEmail === 'yantilina.lili@yandex.ru'">-->
<!--                            <p><a href="/projects_base">Проекты сайта</a></p>-->
<!--                        </template>-->
<!--										</div>-->
                    <div class="content_block__item" :class="{ 'odd': index % 2 === 0, 'even': index % 2 !== 0 }"
                         v-for="(competition, index) in paginatedCompetitions" :key="competition.id">
                        <div class="columns competition_item">
                            <div class="column is-narrow">
<!--                                <img class="competition_avatar"-->
<!--                                     :src="'https://script.moviestart.ru/uploads/images/'+competition.avatar" alt="">-->
                                <ImageRender
                                        class-name="competition_avatar"
                                        :src="get_uploaded_image_asset(competition.avatar)" >
                                </ImageRender>

                            </div>
                            <div class="column">
                                <div class="columns">
                                    <div class="column">
                                        <p v-if="getCompetitionNapravlenie(competition)?.length > 0"
                                           class="competition_napravlenie">{{
																						getCompetitionNapravlenie(competition)
                                            }}</p>
                                        <p class="competition_name">{{ competition.name }}</p>
																				<template v-if="(competition.name.startsWith('Россия - взгляд в будущее! 2024') || competition.name.startsWith('Россия - взгляд в будущее 2025')) && (currentUserEmail === 'fundregion2022@yandex.ru' || currentUserEmail === 'shatlarina@yandex.ru' || currentUserEmail === 'goramo@mail.ru' || currentUserEmail === 'maria_mst@mail.ru' || currentUserEmail === 'sofiapro98@gmail.com' || currentUserEmail === 'tarastasya@mail.ru' || currentUserEmail === 'Tukhareli@fundregion.ru' || currentUserEmail === 'karina@shatters.ru')"><a
                                                :href="'/competition/report_rvvb/'+competition.id" target="_blank">Отчет</a></template>
	                                    
                                    </div>
<!--                                    <div class="column is-narrow">-->
<!--                                        <p class="competition_date">До {{ formatDate(competition.endDate) }}</p>-->
<!--                                    </div>-->
                                </div>

                                <div class="competition_data_table__wrapper">
                                    <table class="competition_data_table">
                                        <tr>
                                            <th>Категории</th>
                                            <th>Всего работ</th>
                                            <th>Требуется оценка</th>
                                        </tr>
                                        <template v-for="(category, index) in competition.categories_data" :key="index">
                                            <tr>
                                                <td>
                                                    <p class="link_competition"><a
                                                            :href="'/project/list_expert/'+competition.id+'/'+category.id">{{
																												category.name
                                                        }}</a></p>
                                                </td>
                                                <td>
                                                    <p class="link_category_count">{{ category.count }}</p>
                                                </td>
                                                <td>
                                                    <div class="not_scored"
                                                         :class="category.notScoredProjects > 0 ? 'has_not_scored' : ''">
                                                        {{ category.notScoredProjects }}
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="margin-top: 30px;margin-left: 25px;">
                        <Pagination
                                :current="current"
                                :pageSize="pageSize"
                                :total="competitions.length"
                                @change="(page)=>{current = page;}"
                        ></Pagination>
                    </div>


										<template v-if="currentUserEmail === 'kartushin@me.com' || currentUserEmail === 'yantilina.lili@yandex.ru'">
                        <div class="column competition_wrapper is-6-desktop col1" style="margin-top: 15px; margin-left: 15px;">
                            <div class="competition_wrapper_inner" style="height: 260px; background: #ccc; display: flex; align-items: center; justify-content: center; position: relative">
                                <div class="competition-image-wrapper" style="">
                                    Избранные проекты
                                </div>
                            </div>
                            <div class="competition-info">
                                <p style="margin-bottom: 0;"><a class="competition-title" href="/project/list_expert_favorite">Избранные проекты</a></p>
                            </div>
                        </div>


										</template>

                </div>



            </template>
            <Spin style="padding-left: 25px;" v-else/>
        </div>
    </div>
</template>



<style scoped>
.competition_item:deep .competition_avatar {
    max-width: 255px;
    border-radius: 16px;
}

.content_block__item {
    padding-left: 25px;
    padding-right: 20px;
    padding-bottom: 45px;
    padding-top: 45px;
}

.content_block__item:first-child {
    padding-top: 0;
}

.competition_item {
    padding-right: 20px;
}

.competition_item:not(:first-child) {
    padding-top: 30px;
}

.project_avatar img {
    max-width: 106px;
    border-radius: 10px;
    border: 1px solid #DB7F1C;
    box-shadow: 0px 0px 70px 0px rgba(239, 162, 79, 0.52) inset, 0px 12px 24px 0px rgba(0, 0, 0, 0.24);
    backdrop-filter: blur(40px);
}

.info_block__header {
    color: #1D232D;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    margin-top: -10px;
    margin-bottom: 20px;
}

.info_block__item {
    margin-bottom: 15px;
}


.info_block__item .col1 {
    color: rgba(29, 35, 45, 0.50);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    width: 150px;
}

.info_block__item .col2 {
    color: #1D232D;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
}

.images__wrapper {
    position: relative;
}

.link_competition {
    margin-bottom: 0;
}

.link_competition a {
    font-weight: 500;
    font-size: 16px;
    line-height: 135%;
    text-decoration: underline;
    text-decoration-skip-ink: none;
    color: #1d232d;
}

.link_category_count, .not_scored {
    font-weight: 400;
    font-size: 15px;
    line-height: 135%;
    color: #1d232d;
    margin-bottom: 0;
}

.competition_data_table {
    width: 100%;
}

.competition_data_table tr td {
    vertical-align: middle;
    padding: 5px;
}

.competition_data_table tr td:first-child {
    padding-right: 15px;
}

.competition_data_table tr td:nth-child(2), .competition_data_table th td:nth-child(2) {
    padding-right: 20px;
    width: 100px;
}

.competition_data_table tr td:nth-child(3) {
    width: 135px;
}

.competition_data_table tr th {
    font-weight: 300;
    font-size: 14px;
    line-height: 135%;
    text-transform: uppercase;
    color: rgba(29, 35, 45, 0.5);
    padding-bottom: 15px;
}

.competition_napravlenie {
    font-weight: 300;
    font-size: 18px;
    line-height: 135%;
    text-transform: uppercase;
    color: #1d232d;
    margin-bottom: 7px;
}

.competition_name {
    font-weight: 700;
    font-size: 24px;
    line-height: 135%;
    margin-bottom: 5px;
    color: #1d232d;
}

.competition_date {
    font-weight: 500;
    font-size: 18px;
    line-height: 135%;
    text-transform: uppercase;
    text-align: center;
    background: linear-gradient(135deg, #f7c100 0.01%, #f69400 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.request_content h2 {
    font-family: "Onest", sans-serif;
    font-weight: 500;
    font-size: 22px;
    color: #1d232d;
    margin-bottom: 30px;
    padding-left: 25px;
}

.project_avatar {
    position: absolute;
    right: -90px;
    top: 10px;
}

.images_column {
    margin-right: 100px;
}

.content table td {
    border: 0;
    padding: 0;
}



.gray_line {
    background: #E3E9F3;
    padding: 20px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    padding-bottom: 0;
}

.cabinet_page .content {
    padding: 0;
    /*overflow: hidden;*/
}

.request_content {
    padding: 30px 0;
    background: #fff;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
}

.content_block__item.even {
    background: #f7f7f7;
}
.competition-info {
    background: #FEF4E5;
    padding: 20px;
}
.competition-image-wrapper {
    position: relative;
    display: flex;
    border-bottom: 5px solid #F69F22;
}

@media (max-width: 1000px) {
    .competition_data_table__wrapper {
        overflow: scroll;
    }

    .request_content h2 {
        font-size: 18px;
    }
    .competition_name {
        font-size: 20px;
        padding-bottom: 0;
		}
    .competition_napravlenie {
        font-size: 16px;
		}
		.competition_date {
				text-align: center;
		}
    .link_competition a {
        font-size: 16px;
		}
		.competition_date {
        margin-bottom: 0;
		}
}
</style>